const SOCIAL_LINKS = [
  {
    href: 'https://www.instagram.com/chunkzters/',
    label: 'Chunkzters on Instagram',
    icon: 'bi-instagram',
  },
  {
    href: 'https://www.tiktok.com/@chunkzters?_r=1&_t=ZN-96lNdL3wLeI',
    label: 'Chunkzters on TikTok',
    icon: 'bi-tiktok',
  },
  {
    href: 'https://snapchat.com/t/GGlEQibd',
    label: 'Chunkzters on Snapchat',
    icon: 'bi-snapchat',
  },
] as const;

export function SocialLinks({ className = '' }: { className?: string }) {
  return (
    <div className={`chunkzters-social ${className}`.trim()}>
      <div className="chunkzters-social-icons" aria-label="Social media">
        {SOCIAL_LINKS.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className="chunkzters-social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.label}
          >
            <i className={`bi ${link.icon}`} aria-hidden />
          </a>
        ))}
      </div>
      <p className="chunkzters-social-tagline mb-0">Follow us on socials</p>
    </div>
  );
}
